module.exports = __webpack_public_path__ + "assets/img/activity_618_vip_cont1.2dbb4c6d.png";